const answeredNo = (val: string) => val === "No"

const useValuationRules = () => {
  
  // TODO: make configurable by dealership; read rules from db host_mapping table
  const rules = [
    // (model: any) =>  answeredNo(model.accidentHistory.value),
    (model: any) =>  {
      return {
        answeredNo: answeredNo(model.isUndrivable.value),
        reason: "Undrivable",
      }
    },
    // (model: any) =>  answeredNo(model.defectsWarnings.value),
    // (model: any) =>  answeredNo(model.exteriorDamage.value),
    (model: any) =>  {
      return {
        answeredNo: answeredNo(model.salvageTitle.value),
        reason: "SalvageTitle",
      }
    },
  ]
  
  function canShowValuation(vehicleModel: any) {
    return rules.every(rule => rule(vehicleModel).answeredNo)
  }

  function cannotShowValuationReasons(vehicleModel: any) {
    return rules.flatMap(rule => rule(vehicleModel).answeredNo ? [] : [rule(vehicleModel).reason])
  }
  
  return {
    canShowValuation,
    cannotShowValuationReasons,
  }
}

export default useValuationRules;